module.exports = __webpack_public_path__ + "static/media/INVESTOR_PLUS.be0b0799.svg";